export default {
  setUser(state, payload) {
    state.token = payload.token;
    state.userId = payload.userId;
    state.didAutoLogout = false;
  },
  setAutoLogout(state) {
    state.didAutoLogout = true;
  },
  setRoomInfo(state,payload) {
    state.roomInfo = payload;
  },
  setRoomList(state,payload) {
    state.roomList = payload;
  },
  updateRoomList(state,payload) {
    if(state.roomList)
    {
      const findItem = state.roomList.find((room)=>room.id === payload.id);
      const idx = state.roomList.indexOf(findItem);
      state.roomList.splice(idx,1,payload);
    //   state.roomList.push(payload);

    }else{
      // state.roomList = new Array();
      state.roomList=[payload];
      console.log('뮤테이션',state.roomList);
    }
  }
  //setMessages(state, payload) {},
  //fetchMessages(state, payload) {},
};
